import { render, staticRenderFns } from "./VolunteerBackendProfileComponent.vue?vue&type=template&id=6bafe4db&scoped=true&"
import script from "./VolunteerBackendProfileComponent.vue?vue&type=script&lang=js&"
export * from "./VolunteerBackendProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerBackendProfileComponent.vue?vue&type=style&index=0&id=6bafe4db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bafe4db",
  null
  
)

export default component.exports